import styled, { css } from 'styled-components';

import type { ChildrenType } from '@xing-com/badge';
import { NotificationBadge } from '@xing-com/badge';
import {
  mediaTopBarHidden,
  mediaTopBarVisible,
  zIndexElevatedLayer4,
} from '@xing-com/layout-tokens';
import { SuperEllipse } from '@xing-com/super-ellipse';
import { spaceL, spaceM, spaceS, spaceXS } from '@xing-com/tokens';

type TopBarSize = 'xsmall' | 'small';

type SuperEllipseWhenTopBarProps = {
  $size: TopBarSize;
};

export const SuperEllipseWhenTopBar = styled(
  SuperEllipse
)<SuperEllipseWhenTopBarProps>`
  ${({ $size }) => {
    if ($size === 'xsmall') {
      return css`
        /* stylelint-disable-next-line media-query-no-invalid */
        @media ${mediaTopBarHidden} {
          display: none;
        }
      `;
    }

    return css`
      /* stylelint-disable-next-line media-query-no-invalid */
      @media ${mediaTopBarVisible} {
        display: none;
      }
    `;
  }}
`;

export const SuperEllipseWrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  position: relative;
`;

const spaceForCount = (countString: ChildrenType | undefined): string => {
  const count = Number(countString);
  if (isNaN(count)) return spaceS;
  if (count < 10) return spaceS;
  if (count > 99) return spaceL;
  return spaceM;
};

export const NotificationBadgeWithCount = styled(NotificationBadge)`
  position: absolute;
  z-index: ${zIndexElevatedLayer4};
  bottom: calc(${spaceXS} * -1);
  right: ${({ children }) => `calc(${spaceForCount(children)} * -1)`};
`;
